module.exports = __webpack_public_path__ + "static/media/View-Specials-Icon-White.f81a6622.svg";